import { AcornsIcon } from '@acorns/icons'
import { Badge, Drawer, Heading, PageDivider } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

const StyledDrawer = styled(Drawer)`
  > div {
    > header {
      > div {
        margin-left: 20px;
      }
      > button {
        margin-right: 20px;
      }
    }
  }
`

const EditPortfolioListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  max-width: 340px;
  width: 100%;
  margin: 30px auto auto;
`

const EditPortfolioListItemButton = styled.button`
  all: unset;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  cursor: pointer;
  width: 340px;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

const EditPortfolioListItemLeft = styled.div`
  display: flex;
  flex-direction: row;
`

const EditPortfolioListItemHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 15px;
`

const EditPortfolioListItemHeader = styled(Heading)`
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 3px;
`
const EditPortfolioListItemSubHeader = styled(Heading)`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: ${style((theme) => theme.colors.stone)};
`

const EditPortfolioListItemIcon = styled(AcornsIcon)`
  width: 24px;
  height: 24px;
  margin: auto 0;
`

const EditPortfolioListItemChevron = styled(AcornsIcon)<{ color?: string }>`
  width: 12px;
  height: 12px;
  margin: auto 0;

  ${(props) =>
    props.color &&
    ` & path {
      stroke: ${props.color};}
  `}
`

const EditProfileHeader = styled(Heading)`
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 30px;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    margin-left: 0px;
  }
`

const EditProfileContainer = styled.div`
  margin: 0px 0px -20px 0px;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    margin: 0px;
    > button {
      margin-bottom: 0px;
    }
  }
`

const AddNewOptionOuterContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 380px;
  margin-top: 10px;
  background-color: ${style((theme) => theme.colors.ivory)};
  padding: 20px;
  border-radius: ${style((theme) => theme.borderRadius.large)};
  > button {
    margin-bottom: 0px;
  }

  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    width: calc(100% + 30px);
    padding: 20px 5%;
    margin-left: -15px;
    > button {
      margin: auto;
    }
  }
`

const TierBadge = styled(Badge)`
  display: flex;
  background-color: ${style((theme) => theme.colors.darkOak)};
  top: 0;
  position: absolute;
  margin-top: -10px;
`

const StarsIcon = styled(AcornsIcon)`
  width: 12px;
  height: 12px;
  margin-right: 5px;
  & path {
    fill: ${style((theme) => theme.colors.white)};
  }
`

const TierBadgeText = styled(Heading)`
  font-size: 12px;
  line-height: 16px;
  color: ${style((theme) => theme.colors.white)};
`

const StyledPageDivider = styled(PageDivider)`
  max-width: 340px;
  width: 100%;
  margin: 30px auto;
`

export {
  EditPortfolioListContainer,
  EditPortfolioListItemButton,
  EditPortfolioListItemLeft,
  EditPortfolioListItemHeaderContainer,
  EditPortfolioListItemHeader,
  EditPortfolioListItemSubHeader,
  EditPortfolioListItemIcon,
  EditPortfolioListItemChevron,
  EditProfileHeader,
  EditProfileContainer,
  AddNewOptionOuterContainer,
  TierBadge,
  StarsIcon,
  TierBadgeText,
  StyledDrawer,
  StyledPageDivider,
}
